<div fxLayout="column">
    <ppw-toolbar [menuTitle]="pageTitle" [showMenu]="true" [singleButton]="true" class="sticky-header">
        <div class="ppw-speed-dial-position">
            <button
                mat-mini-fab
                class="speed-dial-button mat-warn"
                (click)="deleteAccount()"
                *ngIf="selectedUserAccount && !selectedUserAccount.isSystemAccount"
                matTooltip="Delete account">
                <mat-icon>delete_forever</mat-icon>
            </button>

            <button mat-mini-fab class="speed-dial-button" (click)="editAccount()" *ngIf="selectedUserAccount">
                <mat-icon matTooltip="Edit Account" *ngIf="!selectedUserAccount.isSystemAccount">create</mat-icon>
                <mat-icon matTooltip="View Account" *ngIf="selectedUserAccount.isSystemAccount">find_in_page</mat-icon>
            </button>

            <button mat-mini-fab class="speed-dial-button" (click)="createAccount()" matTooltip="Create Account">
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </ppw-toolbar>
    <table mat-table [dataSource]="userAccounts$" class="mat-elevation-z8 ppw-list" fxFill>
        <ng-container matColumnDef="userName">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>User name</th>
            <td mat-cell *matCellDef="let element">{{ element.userName }}</td>
        </ng-container>
        <ng-container matColumnDef="firstName">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>First name</th>
            <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Last name</th>
            <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="identityRoles">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Role</th>
            <td mat-cell *matCellDef="let element">{{ element.identityRoles }}</td>
        </ng-container>
        <ng-container matColumnDef="isLocked">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Locked</th>
            <td mat-cell *matCellDef="let element">{{ element.isLocked ? 'Locked' : '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="accessFailedCounter">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Lockout Count</th>
            <td mat-cell *matCellDef="let element">
                {{ element.accessFailedCounter ? element.accessFailedCounter : '-' }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            [class.ppw-list-highlight]="selectedUserAccount === element"
            *matRowDef="let element; columns: displayedColumns"
            (click)="select(element)"
            (dblclick)="editDoubleClick(element)"></tr>
    </table>
</div>
